import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LessonEdit from './LessonEdit';
import { MoneyDisplay } from 'components';
import capitalise from 'utils/capitalise';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const LessonInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.lesson);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Lesson Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Name (ZH)</TableCell>
              <TableCell>{model.name_zh}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Price</TableCell>
              <TableCell><MoneyDisplay amount={model.price} currency={model.price_currency} /></TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Type</TableCell>
              <TableCell>{capitalise(model.type)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Status</TableCell>
              <TableCell>{capitalise(model.status)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <LessonEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

LessonInfo.propTypes = {
  className: PropTypes.string,
};

export default LessonInfo;
